<template>
  <header class="navbar" :class="isScrolling ? 'is-scrolling' : ''">
    <router-link :to="{ name: 'index' }" class="brand" exact>
      <img v-if="isScrolling && $store.state.mainMenu.status === false" src="/svg/supranet.svg" alt />
      <img v-else src="/svg/supranet-v2.svg" alt />
    </router-link>

    <main-menu :class="isScrolling ? 'is-scrolling' : ''"></main-menu>

    <div class="flex items-center ml-auto">
      <button
        type="button"
        class="main-menu-trigger"
        :class="{ 'active': $store.state.mainMenu.status }"
        @click="toggleMainMenu"
      >
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
import MainMenu from "./MainMenu.vue";

export default {
  components: {
    MainMenu
  },

  data() {
    return {
      isScrolling: false
    };
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    toggleMainMenu() {
      this.$store.state.mainMenu.status = !this.$store.state.mainMenu.status;
    },

    handleScroll() {
      let scrollY = window.scrollY || document.documentElement.scrollTop

      this.isScrolling = scrollY > 0;
    }
  }
};
</script>
